import styled from '@emotion/styled';
import * as Tabs from '@radix-ui/react-tabs';

export const TabsRoot = styled(Tabs.Root)`
  height: 50vh;
  max-height: 650px;
  flex: 0 0 329px;
  padding-right: 16px;
  border-right: 1px solid ${({ theme }) => theme.colors.zinc_200};
  margin-right: 16px;
`;
